//React
import { FunctionComponent, useLayoutEffect, useState } from "react";
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";
import { selectAreaIsState } from "../../../area-info/redux/selectors/select-area-is-state";
import { selectIsQmiFinder } from "../../../system/redux/selectors/select-is-qmi-finder";
import { selectRteApiData } from "../../../results/redux/selectors/rte/select-rte-api-data";

const RteCard: FunctionComponent = (props) => {
	const areaIsState = useAppSelector(selectAreaIsState);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);
	const rteApiData = useAppSelector(selectRteApiData);

	// Defaults
	const defaultFallbackBgMobile = require("../../assets/red-gradient_mobile.jpg");
	const defaultFallbackBgTablet = require("../../assets/red-gradient_tablet.jpg");
	const defaultFallbackBgDesktop = require("../../assets/red-gradient_desktop-wide-tile.jpg");
	const defaultFallbackCtaText = "Act now";
	const defaultFallbackTextLive = "More homes. More savings. Deals end soon.";
	const defaultFallbackTextTeaser = "More homes. More savings. Deals start soon.";

	// Bg Images
	const mobileBgImage = rteApiData?.bgImageSrcMobile == "" ? defaultFallbackBgMobile : rteApiData?.bgImageSrcMobile;
	const tabletBgImage = rteApiData?.bgImageSrcTablet == "" ? defaultFallbackBgTablet : rteApiData?.bgImageSrcTablet;
	const desktopBgImage = rteApiData?.bgImageSrcDesktop == "" ? defaultFallbackBgDesktop : rteApiData?.bgImageSrcDesktop;

	const [tileBgImage, setTileBgImage] = useState(desktopBgImage);

	useLayoutEffect(() => {
		const checkWidthSetImage = () => {
			if (window.innerWidth <= 635) {
				setTileBgImage(mobileBgImage);
			}

			if (window.innerWidth >= 636 && window.innerWidth <= 1281) {
				setTileBgImage(tabletBgImage);
			}
		};

		// check initial width on component mount & set bg image
		checkWidthSetImage();

		window.addEventListener("resize", checkWidthSetImage);

		// cleanup function to remove listener on unmount
		return () => {
			window.removeEventListener("resize", checkWidthSetImage);
		};

	}, []);

	const showTile = (rteApiData.status.toLowerCase() == "teaser" || rteApiData.status.toLowerCase() == "live") ? true : false;

	const tileClass = rteApiData.status.toLowerCase() !== "" ? `${rteApiData.status.toLowerCase()}-red-tag-tile` : "" ;

	const textDivClass = rteApiData.status.toLowerCase() !== "" ? `${rteApiData.status.toLowerCase()}-red-tag-cta-one` : "";

	if (!showTile || areaIsState || isQmiFinder) {
		return null;
	}

	const handleTileClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		const rfiButton = document.querySelector<HTMLButtonElement>("#rfi-btn");
		if (rfiButton) {
			const url = new URL(window.location.href);
			window.history.pushState(null, null, url.origin + url.pathname + "?rfi-rte" + url.search.replace("?", "&") + url.hash);
			rfiButton.click();
		}
	}

	return (
		<div className="coveo-list-layout CoveoResult" role="listitem">
			<a
				role="link"
				tabIndex={0}
				aria-label="RedTag event tile"
				className="cf-rte-tile"
				onClick={(e) => {handleTileClick(e)}}
			>
				<div className={tileClass} style={{ backgroundImage: `url('${tileBgImage}')`, backgroundColor: "#e70a01"}}>
					<div className="red-tag-logo">
						<img src="\Assets\drh\img\rte\L1_Red-Tag-Event_Logo_White.svg" width="50px" />
					</div>
					<div className={textDivClass}>
						{rteApiData?.status.toLowerCase() == "live" && (rteApiData?.textLive == "" ? defaultFallbackTextLive : rteApiData?.textLive)}
						{rteApiData?.status.toLowerCase() == "teaser" && (rteApiData?.textTeaser == "" ? defaultFallbackTextTeaser : rteApiData?.textTeaser)}
					</div>
					<div className="red-tag-cta-two">
						{rteApiData?.status.toLowerCase() == "live" && (rteApiData?.ctaLive == "" ? defaultFallbackCtaText : rteApiData?.ctaLive)}
						{rteApiData?.status.toLowerCase() == "teaser" && (rteApiData?.ctaTeaser == "" ? defaultFallbackCtaText : rteApiData?.ctaTeaser)}
						<span className="banner-arrow">
							<svg
								xmlns="https://www.w3.org/2000/svg"
								viewBox="0 0 15 15"
							>
								<path
									d="m15 7.48-4.63 7.12H5.53l3.04-5.2H0V5.56h8.57L5.53.39h4.84L15 7.48z"
									style={{ fill: "white" }}
								></path>
							</svg>
						</span>
					</div>
				</div>
			</a>
		</div>
	);
};

export default RteCard;
